import styled from "styled-components";
import HistoryBg from "@public/assets/main/history-bg.png"
import {SIZES} from "@/components/constants";

const CompanyHistorySection = ({data}) => {
    return(
        <SectionWrap>
            <div className={"container"}>
                <div className={"history-bg"}><img src={HistoryBg?.src} alt={"회사연혁 이미지"}/></div>
                <div className={"history-info"}>
                    <h2 className={"history-title"} dangerouslySetInnerHTML={{__html: data["company-history"]}}/>
                    <div className={"history-box"}>
                        <div className={"history-line"}></div>
                        <div className={"items-wrap"}>
                            <h3 className={"item-title"} dangerouslySetInnerHTML={{__html: data["history-year1"]}}/>
                            <ul className={"item-inner"}>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["oct25"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["courier-box-business"]}}/>
                                </li>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["aug25"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["recoolware-sponsorship"]}}/>
                                </li>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["jul25"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["recoolware-donation"]}}/>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div className={"history-box"}>
                    <div className={"history-line"}></div>
                        <div className={"items-wrap"}>
                            <h3 className={"item-title"} dangerouslySetInnerHTML={{__html: data["history-year2"]}}/>
                            <ul className={"item-inner"}>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["sep24"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["mou-signed"]}}/>
                                </li>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["aug24"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["venture-business-cert"]}}/>
                                </li>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["jan24"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["app-launch"]}}/>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div className={"history-box"}>
                    <div className={"history-line"}></div>
                        <div className={"items-wrap"}>
                            <h3 className={"item-title"} dangerouslySetInnerHTML={{__html: data["history-year3"]}}/>
                            <ul className={"item-inner"}>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["dec23"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["resource-circulation-award"]}}/>
                                </li>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["feb23"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["department-establishment"]}}/>
                                </li>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["apr22"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["ice-pack-recovery"]}}/>
                                </li>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["oct21"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["reusable-transport-packaging"]}}/>
                                </li>
                                <li className={"box-item"}>
                                    <span className={"inner-title"} dangerouslySetInnerHTML={{__html: data["mar21"]}}/>
                                    <span className={"inner-info"}
                                          dangerouslySetInnerHTML={{__html: data["establishment"]}}/>
                                </li>
                            </ul>
                        </div>
                    </div>


                </div>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 120px 0;
    background-color: #f1f3f7;
    .container{
        margin: 0 auto;
        padding: 0 24px;
        gap: 40px;
        justify-content: center;
        align-items: center;
        display: flex;
        width: 100%;
        flex-direction: column;
        .history-bg{
            display: flex;
            flex: 1 1 0;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img{
                max-width: 564px;
                aspect-ratio: 564 / 483;
            }
        }
        .history-info{
            gap: 40px;
            justify-content: center;
            flex-direction: column;
            flex: 1 1 0;
            display: flex;
            .history-title{
                line-height: 64px;
                font-weight: 700;
                font-size: 18px;
            }
            .history-box{
                gap: 40px;
                align-items: stretch;
                display: flex;
                .history-line{
                    background-image: linear-gradient(180deg, #00913A 0%, #B1E5EC 100%);
                    border-radius: 9999px;
                    width: 4px;
                }
                .items-wrap{
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    .item-title{
                        font-size: 30px;
                        line-height: 36px;
                        font-weight: 700;
                    }
                    .item-inner{
                        gap: 16px;
                        flex-direction: column;
                        display: flex;
                        .box-item{
                            display: flex;
                            gap: 12px;
                            .inner-title{
                                min-width: 100px;
                            }
                            .inner-info{
                                font-size: 12px;
                                line-height: 16px;
                                color: rgba(95, 93, 103, 0.5);
                            }
                        }
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
            .history-info{
                .history-box{
                    .items-wrap{
                        .item-inner{
                            .box-item{
                                .inner-info{
                                    font-size: 14px;
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media not all and (min-width: ${SIZES.MOBILE_L}) {
        .container{
            .history-bg{
                img{
                    max-width: 300px;
                }
            }
            .history-info{
                .history-title{
                    line-height: 28px;
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container{
            flex-direction: row;
            max-width: 768px;
            .history-info{
                .history-box{
                    .items-wrap{
                        .item-title{
                            font-size: 36px;
                            line-height: 40px;
                        }
                        .item-inner{
                            .box-item{
                                gap: 16px;
                                .inner-title{
                                    font-size: 18px;
                                    line-height: 28px;
                                    min-width: 140px;
                                }
                                .inner-info{
                                    font-size: 16px;
                                    line-height: 24px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        .container{
            max-width: 1024px;
            padding: 0 40px;
            .history-info{
                .history-title{
                    font-size: 40px;
                }
                .history-box{
                    .items-wrap{
                        .item-title{
                            font-size: 48px;
                            line-height: 1;
                        }
                        .item-inner{
                            .box-item{
                                gap: 24px;
                                .inner-title{
                                    font-size: 22px;
                                }
                                .inner-info{
                                    font-size: 18px;
                                    line-height: 28px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;
            .history-info{
                .history-box{
                    .items-wrap{
                        .item-title{
                            font-size: 56px;
                        }
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container{
            max-width: 1536px;
        }
    }
`
export default CompanyHistorySection;